import { HttpStatusCodes } from '../constants';
import { ServerException } from './constants';
import {
    BOOKING_COMPLETE_GA_CATEGORY,
    GaActionText,
} from '../pages/BookingComplete/constants';
import { createGaActionCreatorWithLabel } from '../utils';
import { unauthorizedResponse } from '../components/WellGuide/constants';
import { stringifyIdsFromBody } from '../utils/bodyIdTransform';

const FETCHING_WELL_GUIDE_DATA = '@@wellguide/FETCHING_WELL_GUIDE_DATA';
const FETCHING_WELL_GUIDE_SUCCESS = '@@wellguide/FETCHING_WELL_GUIDE_SUCCESS';
const FETCHING_WELL_GUIDE_FAILURE = '@@wellguide/FETCHING_WELL_GUIDE_FAILURE';
const TRACK_CLICK_NEW_BOOKING = '@@wellguide/TRACK_CLICK_NEW_BOOKING';

const apiHost = process.env.API_HOST || '';
const getWellGuideRecommendationsEndpoint = `${apiHost}/api/patient/v1/well-guide-status`;

export const WellGuideActions = {
    FETCHING_WELL_GUIDE_DATA,
    FETCHING_WELL_GUIDE_SUCCESS,
    FETCHING_WELL_GUIDE_FAILURE,
    TRACK_CLICK_NEW_BOOKING,
};

export const fetchingWellGuideData = () => ({
    type: FETCHING_WELL_GUIDE_DATA,
});

function getWellGuideDataFetch() {
    return fetch(getWellGuideRecommendationsEndpoint, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        if (response.status === HttpStatusCodes.OK) {
            return response.json();
        } else if (response.status === HttpStatusCodes.Unauthorized) {
            return unauthorizedResponse.json();
        } else {
            throw new ServerException({ response });
        }
    });
}

export function getWellGuideData() {
    return dispatch => {
        dispatch(fetchingWellGuideData());

        return getWellGuideDataFetch()
            .then(body => {
                body.recommendations = body.recommendations.map(
                    stringifyIdsFromBody
                );
                dispatch(getWellGuideDataSuccess(body));
            })
            .catch(() => {
                dispatch(getWellGuideDataFailure());
            });
    };
}

export const getWellGuideDataFailure = () => ({
    type: FETCHING_WELL_GUIDE_FAILURE,
});

export const getWellGuideDataSuccess = responseBody => ({
    type: FETCHING_WELL_GUIDE_SUCCESS,
    responseBody,
});

export const trackClickNewBooking = (
    procedureId,
    specialtyId,
    numberIncomplete
) =>
    createGaActionCreatorWithLabel(
        TRACK_CLICK_NEW_BOOKING,
        BOOKING_COMPLETE_GA_CATEGORY,
        GaActionText.trackClickNewBooking,
        JSON.stringify({
            procedure_id: procedureId,
            specialty_id: specialtyId,
            incomplete_tasks: numberIncomplete,
        })
    );

export const WellGuideActionCreators = {
    trackClickNewBooking,
    getWellGuideData,
};
